var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-confirm',{attrs:{"confirm-title":"account.delete_account","description":"account.delete_account_inf"},on:{"confirm":function($event){return _vm.$emit('confirm')},"cancel":function($event){return _vm.$emit('closeModal')}}},[_c('iconPerson',{attrs:{"size":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }